// Handles form validation and updates
import stringify from 'json-stringify-safe'

import * as types from '../constants/action_types'

// @flow
export const onChangeInput = (id: string, value: string) =>
    ({ type: types.CHANGE_INPUT, id, value })

// @flow
export const setValidationError = (id: string, error: string) =>
    ({ type: types.VALIDATION_ERROR, id, error })
